import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import Giime from 'giime';
import router from './router';

import App from './App.vue';
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar.vue';
import 'element-plus/theme-chalk/dark/css-vars.css';
// import zhCn from 'element-plus/es/locale/lang/zh-cn';
// element css
// import 'element-plus/es/components/message/style/css';
// import 'element-plus/es/components/message-box/style/css';
// import 'element-plus/es/components/notification/style/css';
// import 'element-plus/es/components/loading/style/css';
import 'element-plus/dist/index.css'; // element-plus
// import 'giime/theme-chalk/element/index.scss'; // element-plus
// import '@/styles/element-ui.scss'; // global css
import 'giime/theme-chalk/index.css'; // giime css变量
import 'giime/dist/index.css'; // giime组件样式

import '@/styles/lib/highlight.less';
import '@/styles/lib/github-markdown.less';
import SvgIcon from '@/components/SvgIcon/index.vue'; // svg component
import 'virtual:svg-icons-register';
import './index.css';

const app = createApp(App);

app.component('SvgIcon', SvgIcon);
app.component('RightToolbar', RightToolbar);
app.use(router);
app.use(createPinia());
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(Giime, { env: import.meta.env, router });
app.mount('#app');
